import { createContext, ReactNode, useCallback } from 'react';
import { useAppDispatch } from '../../services/redux/hooks';
import { useUserWithAttributes } from '../../services/auth/user';
import { fnDictGetIndex, fnDictHasIndex } from '../../services/shared';
import { updateUserAsync } from '../../services/redux/authSlice';
import { AdminContextProps } from '../../types/admin';

export const UserContext = createContext<AdminContextProps | undefined>(undefined);

export const UserProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const dispatch = useAppDispatch();
  const service = useUserWithAttributes();

  const getObjectAttribute = useCallback((path: string) => {
    return fnDictGetIndex(service, `userattributes.prefs.${path}`);
  }, [service]);
  const getObjectAttributeExists = (path: string) => {
    return fnDictHasIndex(service, path);
  };
  const updateObjectAttribute = useCallback((path: string, value: any) => {
    dispatch(updateUserAsync({ keyaddress: `userattributes.prefs.${path}`, keyvalue: value }));
  }, [dispatch]);

  return (
    <UserContext.Provider value={{ getObjectAttribute, updateObjectAttribute,getObjectAttributeExists }}>
      {children}
    </UserContext.Provider>
  );
};
